export const jobNum = {
  jobNumStatus: [{
    value: 0, label: '全部'
  }, {
    value: 2, label: '正常'
  }, {
    value: 9, label: '禁用'
  }],
  jobNumSelectStatus: [{
    value: 0, label: '有效'
  }, {
    value: 9, label: '禁用'
  }],
  jobNumListStatus: [{
    value: 0, label: '有效'
  }, {
    value: 9, label: '禁用'
  }, {
    value: -20, label: '无效'
  }],
  jobNumUseStatus: [{
    value: 0, label: '有效'
  }, {
    value: 1, label: '禁用'
  }],
  jobNumType: [{ // 0、专代工号（原自有工号）1、合作工号 2、个代工号
    value: 0, label: '专代'
  }, {
    value: 2, label: '个代'
  }, {
    value: 1, label: '合作'
  }],
  renewalJobState: [{
    value: false, label: '否'
  }, {
    value: true, label: '是'
  }],
  JobNoRange: [{
    value: 0,
    label: '车险'
  }, {
    value: 1,
    label: '非车'
  }, {
    value: 2,
    label: '车险及非车'
  }],
  useageSceneList: [{
    value: 1,
    label: '保单录入'
  }, {
    value: 2,
    label: '报价出单'
  }],
  shareLogin: [{
    value: 0,
    label: '不共享'
  }, {
    value: 1,
    label: '共享'
  }],
  loginType: [{
    value: 1,
    label: '账号+密码'
  }, {
    value: 2,
    label: '手机+短信'
  }, {
    value: 3,
    label: '二维码'
  }],
  tpLoginType: [{
    value: 1,
    label: 'P13'
  }, {
    value: 2,
    label: 'P09'
  }, {
    value: 4,
    label: '手机号+密码'
  }, {
    value: 5,
    label: '手机号+验证码'
  }],
  rstcLoginType: [{
    value: 1,
    label: '身份证+密码'
  }, {
    value: 2,
    label: '手机号+验证码'
  }, {
    value: 3,
    label: '手机号+密码'
  }],
  searchType: [{
    value: 1,
    label: '保单号'
  }, {
    value: 2,
    label: '投保单号'
  }, {
    value: 3,
    label: '订单号'
  }, {
    value: 4,
    label: '申请单号'
  }, {
    value: 5,
    label: '保单号/投保单号'
  }, {
    value: 6,
    label: '业务员名称'
  }, {
    value: 7,
    label: '保单号/订单号'
  }, {
    value: 8,
    label: '保单号/申请单号'
  }, {
    value: 9,
    label: '协议信息/业务归属/修理厂'
  }, {
    value: 10,
    label: '保单号/暂存单号'
  }, {
    value: 11,
    label: '送修厂名称'
  }]
}

export default {
  jobNum
}



// WEBPACK FOOTER //
// ./src/data/jobnum.js